import { Skeleton } from "@material-ui/lab";

import { THUMBNAIL_SIZES } from "common/constants";
import { Slide } from "js/core/models/slide";
import Thumbnails from "js/core/models/thumbnails";
import { getAverageImageColor } from "js/core/utilities/imageUtilities";
import Spinner from "js/react/components/Spinner";
import { ContextMenu } from "js/react/components/UiComponents";
import { themeColors } from "js/react/sharedStyles";
import { mouseDragItems } from "js/react/views/SharedResources/utils/mouseDragHelper";
import { $, _ } from "js/vendor";
import React, { Component, Fragment } from "react";
import styled, { css } from "styled-components";

const Frame = styled.div`
`;

const getGridColumnsFromWidth = width => {
    if (width > 1440) return 4;
    if (width > 1200) return 3;
    if (width > 900) return 2;
    return 1;
};

const StyledThumbnailGrid = styled.div`
    display: grid;
    grid-column-gap: ${props => props.colGap || 30}px;
    grid-row-gap: ${props => props.rowGap || 30}px;
    grid-auto-rows: max-content;
    
    grid-template-columns: repeat(${props => props.columns || 4}, minmax(0, 1fr));
    grid-template-columns: repeat(${props => props.forcedColumnCount || props.columns - 2 || 1}, minmax(0, 1fr));
    @media(min-width: 0px) {
    }
    @media(min-width: 750px) {
      grid-template-columns: repeat(${props => props.forcedColumnCount || props.columns - 1 || 2}, minmax(0, 1fr));
    }
    @media(min-width: 1200px){
      grid-template-columns: repeat(${props => props.columns || 4}, minmax(0, 1fr));;
    }
    @media(min-width: 1700px){
      grid-template-columns: repeat(${props => props.forcedColumnCount != null ? props.forcedColumnCount : (props.columns + 1 || 5)}, minmax(0, 1fr));;
    }
    label {
        font-size: 14px;
        color: #333;
        letter-spacing: 0px;
        font-weight: 600;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
        text-align: center;
    }
`;

export const ThumbnailGridSkeleton = styled(Skeleton)`
    &&& {
        display: flex;
        transform: none;
        min-height: 220px;
    }
`;

export class ThumbnailGrid extends Component {
    handleItemClick = item => {
        this.props.onItemSelected && this.props.onItemSelected(item);
    }

    handleItemDoubleClick = item => {
        this.props.onItemDoubleClick && this.props.onItemDoubleClick(item);
    }

    render() {
        const { items, thumbnailClass, renderThumbnail, thumbnailSize, style, columns, colGap, rowGap, firstItem, showThemeThumbnails, selectedItem, thumbnailProps, forcedColumnCount } = this.props;

        const styles = { ...style };
        if (thumbnailSize) {
            styles.gridTemplateColumns = `repeat(auto-fill, ${thumbnailSize}px`;
        }

        return (
            <StyledThumbnailGrid columns={columns} forcedColumnCount={forcedColumnCount} colGap={colGap} rowGap={rowGap} className="thumbnail-grid"
                style={styles}>
                {firstItem ? firstItem : null}
                {
                    items.map(item => {
                        if (!item) {
                            // error: should not happen unless there's a bug, but avoids taking down the entire view
                            return <div style={{ background: "#929292", fontSize: 58, textAlign: "center" }}>?</div>;
                        }
                        if (renderThumbnail) {
                            return <Fragment key={item.id}>{renderThumbnail({ item })}</Fragment>;
                        }
                        return React.createElement(thumbnailClass, {
                            key: item.id,
                            item: item,
                            selected: selectedItem == item,
                            showThemeThumbnails: showThemeThumbnails,
                            onClick: event => this.handleItemClick(item, event),
                            onDoubleClick: event => this.handleItemDoubleClick(item, event),
                            ...thumbnailProps
                        });
                    })
                }
            </StyledThumbnailGrid>
        );
    }
}

export class MultiSelectThumbnailGrid extends Component {
    state = {
        selection: [],
        dragBounds: null,
        responsiveColumnCount: null
    }

    constructor() {
        super();

        this.gridRef = React.createRef();
    }

    componentDidMount() {
        const { responsiveColumns } = this.props;

        if (responsiveColumns) {
            this.setState({ responsiveColumnCount: getGridColumnsFromWidth(window.innerWidth) });
            window.addEventListener("resize", this.resizeListener);
        }
    }

    componentWillUnmount() {
        const { responsiveColumns } = this.props;

        if (responsiveColumns) {
            window.removeEventListener("resize", this.resizeListener);
        }
    }

    resizeListener = () => this.setState({ responsiveColumnCount: getGridColumnsFromWidth(window.innerWidth) });

    handleGridMouseDown = event => {
        if ($(event.target).hasClass("thumbnail-grid")) {
            this.setState({ selection: [] });
            this.props.onItemSelected && this.props.onItemSelected([]);
        }
    }

    handleThumbnailMouseDown = (item, event) => {
        const { items, allowDragging } = this.props;

        event.stopPropagation();
        let selection = this.state.selection;
        this._itemWasSelectedOnMouseDown = selection.contains(item.id);
        const isModifierKeyPressed = window.navigator.platform.includes("Mac") ? event.metaKey : event.ctrlKey;
        if (this.props.allowMultiSelect && isModifierKeyPressed) {
            if (selection.contains(item.id)) {
                selection.remove(item.id);
            } else {
                selection.push(item.id);
            }
        } else if (this.props.allowMultiSelect && event.shiftKey && selection.length) {
            let startIndex = this.startSelectionIndex || 0;
            let endIndex = _.findIndex(items, o => o.id == item.id);

            if (endIndex > startIndex) {
                for (let i = startIndex + 1; i <= endIndex; i++) {
                    let item = items[i];
                    if (!selection.contains(item.id)) {
                        selection.push(item.id);
                    }
                }
            } else {
                for (let i = startIndex; i >= endIndex; i--) {
                    let item = items[i];
                    if (!selection.contains(item.id)) {
                        selection.push(item.id);
                    }
                }
            }
        } else {
            if (!selection.contains(item.id)) {
                selection = [item.id];
                this.startSelectionIndex = _.findIndex(items, o => o.id == item.id);
            }
            if (allowDragging) {
                this.dragItems(event, item.id, selection);
            }
        }
        this.setState({ selection: selection });

        this.props.onItemSelected && this.props.onItemSelected(items.filter(item => selection.contains(item.id)));
    }

    handleThumbnailDoubleClick = item => {
        this.setState({ selection: [item.id] });
        this.props.onDoubleClick && this.props.onDoubleClick(item);
    }

    handleContextMenu = (item, event) => {
        const { items } = this.props;
        const { selection } = this.state;
        const nextSelection = selection.contains(item.id) ? selection : [item.id];

        event.preventDefault();
        this.setState({
            selection: nextSelection,
            showContextMenu: true,
            contextMenuX: event.pageX,
            contextMenuY: event.pageY
        });

        if (nextSelection !== selection) {
            this.props.onItemSelected && this.props.onItemSelected(items.filter(i => nextSelection.contains(i.id)));
        }
    }

    handleCloseContextMenu = () => {
        this.setState({ showContextMenu: false });
    }

    handleThumbnailMenuClick = item => {
        const { items } = this.props;
        const selection = [item.id];

        this.setState({ selection });
        this.props.onItemSelected && this.props.onItemSelected(items.filter(i => i.id === item.id));
    }

    dragItems(event, mousedItemId, selection) {
        const { items } = this.props;

        this._dragStarted = false;

        mouseDragItems({
            event,
            container: this.gridRef.current,
            mousedItem: { id: mousedItemId },
            selection: selection.map(id => ({ id })),
            onDidStartDrag: () => {
                this._dragStarted = true;
            },
            onStartDragItems: () => {
                this.props.onStartDragItems?.(items.filter(item => selection.contains(item.id)));
            },
            onDropDragItems: (_dragItems, dropEvent) => {
                this.props.onDropDragItems?.(items.filter(item => selection.contains(item.id)), dropEvent);
            },
        });
    }

    handleThumbnailMouseUp = (item, event) => {
        if (event.shiftKey || event.metaKey || event.ctrlKey) return;
        const { items } = this.props;
        const { selection } = this.state;
        if (!this._dragStarted && this._itemWasSelectedOnMouseDown && selection.contains(item.id)) {
            if (selection.length === 1) {
                this.setState({ selection: [] });
                this.props.onItemSelected && this.props.onItemSelected([]);
            } else {
                this.setState({ selection: [item.id] });
                this.props.onItemSelected && this.props.onItemSelected(items.filter(i => i.id === item.id));
            }
        }
    }

    // pull out the item renderer so we don’t inline the same callback over and over
    renderItem = (item, idx) => {
        const {
            renderThumbnail,
            thumbnailClass,
            thumbnailProps = {},
            readOnly,
            showThemeThumbnails = false,
            items,
            renderContextMenuItems,
            getItemKey
        } = this.props;
        const { selection } = this.state;

        if (renderThumbnail) {
            return <Fragment key={getItemKey ? getItemKey(item) : idx}>{renderThumbnail(item)}</Fragment>;
        }

        // assign dynamic component to uppercase variable for JSX
        const ThumbnailComponent = thumbnailClass;

        return (
            <ThumbnailComponent
                key={`${item.id}:${idx}`}
                item={item}
                onMouseDown={e => this.handleThumbnailMouseDown(item, e)}
                onMouseUp={e => this.handleThumbnailMouseUp(item, e)}
                onDoubleClick={e => this.handleThumbnailDoubleClick(item, e)}
                onContextMenu={e => this.handleContextMenu(item, e)}
                selected={selection.contains(item.id)}
                readOnly={readOnly}
                showThemeThumbnails={showThemeThumbnails}
                allSelected={items.filter(it => selection.contains(it.id))}
                renderContextMenuItems={renderContextMenuItems}
                {...thumbnailProps}
                onMenuClick={this.handleThumbnailMenuClick}
            />
        );
    }

    render() {
        const { selection, showContextMenu, contextMenuX, contextMenuY, responsiveColumnCount } = this.state;
        const { items, columns, forcedColumnCount, colGap, rowGap, renderContextMenuItems, gridContainerStyle, responsiveColumns, isLoadingMore } = this.props;

        const columnsToUse = responsiveColumns ? (responsiveColumnCount ?? getGridColumnsFromWidth(1200)) : (columns ?? 4);
        const forcedColumnCountToUse = responsiveColumns ? (responsiveColumnCount ?? getGridColumnsFromWidth(1200)) : forcedColumnCount;

        const filteredSelection = items.filter(item => selection.contains(item.id));
        const contextMenuItems = showContextMenu && renderContextMenuItems
            ? renderContextMenuItems(filteredSelection)
            : null;

        let skeletonsCount = 0;
        if (isLoadingMore) {
            if (items.length % columnsToUse === 0) {
                skeletonsCount = columnsToUse;
            } else {
                skeletonsCount = columnsToUse - (items.length % columnsToUse);
            }
        }

        return (
            <Frame style={{ ...gridContainerStyle }} onMouseDown={this.handleGridMouseDown}>
                <StyledThumbnailGrid
                    ref={this.gridRef}
                    columns={columnsToUse}
                    forcedColumnCount={forcedColumnCountToUse}
                    colGap={colGap}
                    rowGap={rowGap}
                    className="thumbnail-grid"
                >
                    {items.map(this.renderItem)}
                    {Array.from({ length: skeletonsCount }).map((_, idx) => <ThumbnailGridSkeleton key={idx} />)}
                </StyledThumbnailGrid>
                {
                    showContextMenu &&
                    contextMenuItems &&
                    <ContextMenu
                        x={contextMenuX}
                        y={contextMenuY}
                        onClose={this.handleCloseContextMenu}
                    >
                        {contextMenuItems}
                    </ContextMenu>
                }
            </Frame>
        );
    }
}

export const ThumbnailContainer = styled.div.attrs(({ dataId }) => ({
    // Used for identifying the div in cypress tests
    "data-id": dataId
}))`
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  justify-content: center;
  gap: 5px;
`;

export const ThumbnailDiv = styled.div.attrs({ "data-test-id": "thumbnail-div" })`
    position: relative;
    display: flex;
    width: 100%;
    background: white;
    align-items: center;
    justify-content: center;
    outline: ${props => props.selected ? `solid 2px ${themeColors.ui_blue}` : "none"};
    transition: ${props => props.$disableSizeTransition ? "box-shadow 0.2s" : "all 0.2s"};

    ${({ readOnly = false }) => !readOnly && css`
        &:hover{
            box-shadow: 0 0 12px rgba(0,0,0, 0.25) !important;
        }
    `}
    
    &.loading {
        padding-top: 56.25%;
        img {
            position: absolute;
            top: 0px;
        }
    }

    img {
        position: absolute;
        top: 0px;
        width: 100%;
        height: 100%;
        object-fit: contain;
        transition: opacity 600ms;
    }

    .badge {
        position: absolute;
        padding: 4px 8px;
        border-radius: 4px;
        color: white;
        background: orangered;
        text-transform: uppercase;
        font-size: 10px;
        font-weight: 600;
        top: -10px;
        &.info {
            background: #11a9e2;
        }
        &.warning {
            background: orangered;
        }
    }
`;

export class Thumbnail extends Component {
    _isMounted = null;

    state = {
        isLoaded: false,
        renderDarkBackground: false,
    }

    constructor() {
        super();
        this.ref = React.createRef();
    }

    componentDidMount() {
        this._isMounted = true;
        this.loadImage();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    loadImage() {
        const { url } = this.props;
        if (!url || this._isMounted === false) return;
        const image = new Image();
        image.crossOrigin = "Anonymous";
        image.onload = () => {
            const { r, g, b, hasAlpha } = getAverageImageColor(image);
            if (hasAlpha && r > 240 && g > 240 && b > 240) {
                this.setState({
                    isLoaded: true,
                    renderDarkBackground: true
                });
            } else {
                this.setState({
                    isLoaded: true
                });
            }
        };
        image.src = url;
    }

    componentDidUpdate(prevProps, prevState) {
        const { url } = this.props;
        if (url !== prevProps.url) {
            this.setState({ isLoaded: false });
            this.loadImage();
        }
    }

    render() {
        const { url, selected, onMouseDown, onClick, onDoubleClick, style = {}, imageStyle = {}, showSpinner, className, readOnly = false, disableSizeTransition = false, children } = this.props;
        const { isLoaded, renderDarkBackground } = this.state;

        return (
            <ThumbnailDiv className={`thumbnail ${className ?? ""}`}
                readOnly={readOnly}
                ref={this.ref}
                selected={selected}
                $disableSizeTransition={disableSizeTransition}
                onMouseDown={onMouseDown}
                onClick={onClick}
                onDoubleClick={onDoubleClick}
                style={{ ...style, paddingBottom: "56.25%", backgroundColor: renderDarkBackground ? "#333" : "white" }}>
                {url && <img src={url} style={!isLoaded ? { ...imageStyle, opacity: 0 } : { ...imageStyle, opacity: 1 }} />}
                {(!isLoaded && showSpinner) && <Spinner />}
                {children}
            </ThumbnailDiv>
        );
    }
}

export class ThumbnailBadge extends Component {
    render() {
        const { type, children } = this.props;

        return (
            <div className={`badge ${type}`}>
                {children}
            </div>
        );
    }
}

const thumbnailStroke = "1px solid rgba(0, 0, 0, 0.05)";

const StyledThumbnail = styled(Thumbnail)`
    box-sizing: border-box;
    border: ${thumbnailStroke};
`;

export class EmptySlideThumbnail extends Component {
    render() {
        const {
            className,
            renderDarkBackground,
            style
        } = this.props;
        return (<ThumbnailContainer className="thumbnail-container" style={style}>
            <ThumbnailDiv className={`thumbnail ${className ?? ""}`}
                style={{ ...style, paddingBottom: "56.25%", backgroundColor: renderDarkBackground ? "#333" : "white", boxSizing: "border-box", border: thumbnailStroke }}>
            </ThumbnailDiv>
        </ThumbnailContainer>);
    }
}

export class SlideThumbnail extends Component {
    state = {
        url: "",
    }

    async componentDidMount() {
        let { slideId, presentationOrLinkId = null, highQuality, modifiedAt } = this.props;

        if (!modifiedAt) {
            const slide = new Slide({ id: slideId }, { autoSync: false });
            await slide.load();
            modifiedAt = slide.get("modifiedAt");
        }

        const url = await Thumbnails.getSignedUrlAndLoad(slideId, modifiedAt, presentationOrLinkId, THUMBNAIL_SIZES[highQuality ? "large" : "small"].suffix);
        this.setState({ url });
    }

    render() {
        const { onClick, selected, style, readOnly } = this.props;
        const { url } = this.state;

        return (
            <ThumbnailContainer className="thumbnail-container" style={style}>
                <StyledThumbnail onClick={onClick} url={url} selected={selected} readOnly={readOnly} />
            </ThumbnailContainer>
        );
    }
}
